import { http, HttpResponse } from 'msw'

export const mockCreateCustomerCard = http.post(
  '/my-business/api/agency/v1/customers/:customerId/cards',
  () =>
    HttpResponse.json({ timestamp: new Date().toISOString() }, { status: 201 }),
)
